import { NewsState } from './types';

export const state = (): NewsState => initialState();

export const initialState = (): NewsState => ({
  newss: {
    items: [],
    isLoading: false,
    total: 0,
    searchParams: {
      dataOption: {
        page: 1,
        itemsPerPage: 1,
        sortBy: ['fromDate'],
        sortDesc: [true],
        groupBy: [],
        groupDesc: [],
        multiSort: true,
        mustSort: false,
      },
      filter: '',
      orClauseFieldsIds: ['text', 'subject'],
    },
  },
});
